const pixKeyTypeTransfeeraAPI = require('../pix/keyType');

const pixKeyType = {
  cpf: 'cpf',
  cnpj: 'cnpj',
  email: 'email',
  phone: 'phone',
  evp: 'evp',
  convertToPayoutEngine(type) {
    return {
      [pixKeyTypeTransfeeraAPI.CPF]: this.cpf,
      [pixKeyTypeTransfeeraAPI.CNPJ]: this.cnpj,
      [pixKeyTypeTransfeeraAPI.EMAIL]: this.email,
      [pixKeyTypeTransfeeraAPI.TELEFONE]: this.phone,
      [pixKeyTypeTransfeeraAPI.CHAVE_ALEATORIA]: this.evp
    }[type];
  }
};

module.exports = pixKeyType;
